import { Smartphone } from "lucide-react";
import React from "react";

import { IgTooltip } from "@intelligems/ig-theme/IgTooltip";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";
import {
  handleSwitchToMobile,
  isMobileDevice,
} from "@src/utils/deviceDetection";

const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "$collapsed",
})<{ $collapsed?: boolean }>(({ theme }) => ({
  marginBottom: theme.spacing(1),
  "& .MuiListItemButton-root": {
    borderRadius: 8,
    minHeight: 32,
    border: `${theme.igBorders.core.default} 1px solid`,
    color: "white",
    "&:hover, &:focus": {
      backgroundColor: theme.igBorders.core.default,
    },
  },
  "& .MuiListItemIcon-root": {
    paddingRight: theme.spacing(2),
    minWidth: "16px",
  },
  variants: [
    {
      props: ({ $collapsed }) => $collapsed,
      style: {
        "& .MuiListItemButton-root": {
          display: "flex !important",
          justifyContent: "center !important",
          alignItems: "center !important",
          padding: "0 !important",
        },
      },
    },
    {
      props: ({ $collapsed }) => $collapsed,
      style: {
        "& .MuiListItemIcon-root": {
          padding: "0 !important",
          justifyContent: "center !important",
          display: "flex !important",
        },
      },
    },
  ],
}));

interface SwitchToMobileProps {
  drawerOpen?: boolean;
}

export const SwitchToMobile = ({ drawerOpen = true }: SwitchToMobileProps) => {
  const theme = useTheme();
  const experience = useSelector(selectedExperience);

  // Only show if user is on mobile device
  if (!isMobileDevice()) {
    return null;
  }

  const getTooltipContent = () => {
    if (drawerOpen) {
      return "";
    }
    return "Switch to Mobile";
  };

  return (
    <IgTooltip placement="right" title={getTooltipContent()}>
      <StyledListItem
        disablePadding
        className="SwitchToMobile-listItem"
        $collapsed={!drawerOpen}
      >
        <ListItemButton onClick={() => handleSwitchToMobile(experience)}>
          <ListItemIcon sx={{ color: theme.igIconColors.light }}>
            <Smartphone size={18} />
          </ListItemIcon>
          {drawerOpen ? (
            <ListItemText
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
              primary="Switch to Mobile"
            />
          ) : null}
        </ListItemButton>
      </StyledListItem>
    </IgTooltip>
  );
};
